import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AUTO_COHORT_SOURCE, ICohortSourceSelection } from './components/CohortSourceSelect';
import { RootState } from '../../../core/store';

interface ICohortSourceState {
	selection: ICohortSourceSelection;
}

const initialState: ICohortSourceState = {
	selection: AUTO_COHORT_SOURCE,
};

const cohortSourceSlice = createSlice({
	name: 'cohortSource',
	initialState,
	reducers: {
		setCohortSource: (state, action: PayloadAction<ICohortSourceSelection>) => {
			state.selection = action.payload;
		},
		resetCohortSource: (state) => {
			state.selection = AUTO_COHORT_SOURCE;
		},
	},
});

export const { setCohortSource, resetCohortSource } = cohortSourceSlice.actions;
export const selectCohortSource = (state: RootState) => state.cohortSourceSlice.selection;
export default cohortSourceSlice.reducer;
